import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../AuthContext";

const CommentModeration = () => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { token, user } = useAuth();

  useEffect(() => {
    if (user && (user.role === "admin" || user.role === "staff")) {
      fetchPendingComments();
    }
    // eslint-disable-next-line
  }, []);

  const fetchPendingComments = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/blog/comments/pending`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setComments(response.data);
    } catch (err) {
      setError("Failed to fetch pending comments.");
      console.error(err);
    }
    setLoading(false);
  };

  const handleModerate = async (commentId, action) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/blog/comments/${commentId}/${action}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setComments((prev) => prev.filter((c) => c._id !== commentId));
    } catch (err) {
      setError(`Failed to ${action} comment.`);
      console.error(err);
    }
  };

  if (!user || (user.role !== "admin" && user.role !== "staff")) {
    return <div>Access denied. Staff/Admin only.</div>;
  }

  return (
    <div>
      <h2>Pending Blog Comments Moderation</h2>
      {loading && <div>Loading...</div>}
      {error && <div className="error-message">{error}</div>}
      {comments.length === 0 && !loading && <div>No pending comments.</div>}
      <ul>
        {comments.map((comment) => (
          <li
            key={comment._id}
            style={{
              marginBottom: "1.5rem",
              borderBottom: "1px solid #eee",
              paddingBottom: "1rem",
            }}
          >
            <div>
              <strong>Post:</strong> {comment.post?.title || "N/A"}
            </div>
            <div>
              <strong>Author:</strong> {comment.author?.username || "Unknown"}
            </div>
            <div>
              <strong>Content:</strong> {comment.content}
            </div>
            <button
              style={{ marginRight: "1rem" }}
              onClick={() => handleModerate(comment._id, "approve")}
            >
              Approve
            </button>
            <button
              onClick={() => handleModerate(comment._id, "reject")}
              style={{ color: "red" }}
            >
              Reject
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CommentModeration;
